import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSLongFormTextTagName: string = 'hhds-long-form-text';
const TAG_NAME: string = HHDSLongFormTextTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSLongFormTextAttrNames = {};

//const Attrs = HHDSLongFormTextAttrNames;

export class HHDSLongFormText extends Component {
	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = /* html */ `
      <div class="${TAG_NAME}">
				<div class="container">
					<div class="grid">
						<div class="${TAG_NAME}__content col-span-4 md:col-start-2 md:col-span-10 lg:col-start-5 lg:col-span-16">
							<slot></slot>
						<div>
					<div>
				</div>
			</div>
    `;

		// Helper/tidiness method for defining this.shadow.innerHTML with
		// global styles and component styles prefixed to the supplied HTML.
		// Using this universally would ensure that we can easily alter this
		// structure across all components.
		this.setInnerHtml('', '', html);

		this.observeSlotChanges(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
